import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/col/index.js
// module id = 280
// module chunks = 0